import moment from "moment";
import { SearchHistoryTypes, UserTypes } from "../../../../types";
import ButtonV2 from "../../buttonV2";
import { MouseEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import {
  selectReference,
  setCaseDetailModal,
  setCaseFormModal,
  setDeleteModal,
  setEditMode,
  setJudicialDivision,
  setJudicialDivisionDeleteModal,
  setJudicialDivisionModal,
  setLocalgovernment,
  setLocalgovernmentDeleteModal,
  setLocalgovernmentModal,
  setPlatformModal,
  setSelectedCaseDetails,
  setSelectedProperty,
  setSelectedUser,
} from "../../../../states/slices/globalReducer";
import {
  DOTS_BTN,
  EDIT_ICON,
  EYE,
  PENCIL,
  TRASH_CAN,
  VERTICAL_OPTIONS,
} from "../../../../assets";
import clsx from "clsx";
import { getStates } from "../../../../Services/services";
import { useQuery, useQueryClient } from "react-query";
import { updateUserStatus } from "../../../../Services/admin.service";
import { toast } from "react-hot-toast";
import { formatCurrency } from "../../../../utils";

export const SEARCH_HISTORY_COLUMN = [
  {
    Header: "Property Title",
    accessor: "",
    Cell: ({ row }: { row: { original: SearchHistoryTypes } }) => {
      return (
        <span className="text-sm font-medium text-[#4D4D4D]">
          {row?.original?.title}
        </span>
      );
    },
  },
  {
    Header: "Location",
    accessor: "",
    Cell: ({ row }: { row: { original: SearchHistoryTypes } }) => {
      return (
        <span className="text-sm font-medium text-[#4D4D4D]">
          {row?.original?.address?.length > 20
            ? `${row?.original?.address.slice(0, 20)}...`
            : row?.original?.address}
        </span>
      );
    },
  },
  {
    Header: "Status",
    accessor: "",
    Cell: ({ row }: { row: { original: SearchHistoryTypes } }) => {
      return (
        <div className="w-fit h-full flex items-center gap-x-1 p-2 rounded-lg bg-[#00AD201A]">
          <div className="w-[5px] h-[5px] rounded-full bg-[#00A63E]" />
          <span className="text-xs font-medium text-[#00A63E]">
            {row?.original?.status}
          </span>
        </div>
      );
    },
  },
  {
    Header: "Plan Number",
    accessor: "survery_plan_number",
    Cell: ({ row }: { row: { original: SearchHistoryTypes } }) => {
      return (
        <span className="text-sm font-medium text-[#4D4D4D]">
          {row?.original?.survey_plan_number}
        </span>
      );
    },
  },
  {
    Header: "Date",
    accessor: "action",
    Cell: ({ row }: { row: { original: SearchHistoryTypes } }) => {
      return (
        <span className="text-sm font-medium text-[#4D4D4D]">
          {moment(row?.original?.created_at).format("YYYY-D-MM")}
        </span>
      );
    },
  },
  {
    Header: "Action",
    accessor: "",
    Cell: ({ row }: { row: { original: SearchHistoryTypes } }) => {
      const navigate = useNavigate();
      const dispatch = useAppDispatch();
      return (
        <ButtonV2
          title={"View Details"}
          btnStyle={"w-full h-full p-2 rounded-lg bg-globalGold"}
          textStyle={"text-[#FAFAFA] font-semibold text-xs"}
          handleClick={() => {
            navigate(`/individual/search-details?idref=${row?.original?.id}`);
            dispatch(setSelectedProperty(row?.original));
          }}
        />
      );
    },
  },
];
export const SEARCH_RESULT_COLUMN = [
  {
    Header: "Property Title",
    accessor: "",
    Cell: ({ row }: { row: { original: SearchHistoryTypes } }) => {
      return (
        <span className="text-sm font-medium text-[#4D4D4D]">
          {row?.original?.title}
        </span>
      );
    },
  },

  {
    Header: "Title Number",
    accessor: "survery_plan_number",
    Cell: ({ row }: { row: { original: SearchHistoryTypes } }) => {
      return (
        <span className="text-sm font-medium text-[#4D4D4D]">
          {row?.original?.title_number}
        </span>
      );
    },
  },
  {
    Header: "Location",
    accessor: "",
    Cell: ({ row }: { row: { original: SearchHistoryTypes } }) => {
      return (
        <span className="text-sm font-medium text-[#4D4D4D]">
          {row?.original?.address?.length > 20
            ? `${row?.original?.address.slice(0, 20)}...`
            : row?.original?.address || "-"}
        </span>
      );
    },
  },
  {
    Header: "Date Created",
    accessor: "action",
    Cell: ({ row }: { row: { original: SearchHistoryTypes } }) => {
      return (
        <span className="text-sm font-medium text-[#4D4D4D]">
          {moment(row?.original?.created_at).format("YYYY-D-MM")}
        </span>
      );
    },
  },
  {
    Header: "Action",
    accessor: "",
    Cell: ({ row }: { row: { original: SearchHistoryTypes } }) => {
      const navigate = useNavigate();
      const dispatch = useAppDispatch();
      const reference = useAppSelector(selectReference);
      return (
        <ButtonV2
          title={"View Details"}
          btnStyle={"w-full h-full p-2 rounded-lg bg-globalGold"}
          textStyle={"text-[#FAFAFA] font-semibold text-xs"}
          handleClick={() => {
            navigate(
              `/individual/search-details?idref=${
                row?.original?.id
              }&reference=${reference || ""}`,
            );
            dispatch(setSelectedProperty(row?.original));
          }}
        />
      );
    },
  },
];
export const CASE_COLUMN = [
  {
    Header: "Property Title",
    accessor: "",
    Cell: ({ row }: { row: { original: SearchHistoryTypes } }) => {
      return (
        <span className="text-sm font-medium text-[#4D4D4D]">
          {row?.original?.title}
        </span>
      );
    },
  },
  {
    Header: "Parties",
    accessor: "",
    Cell: ({ row }: { row: { original: SearchHistoryTypes } }) => {
      return (
        <span className="text-sm font-medium text-[#4D4D4D]">
          {row?.original?.parties?.length > 20
            ? `${row?.original?.parties.slice(0, 20)}...`
            : row?.original?.parties}
        </span>
      );
    },
  },
  {
    Header: "Suit Number",
    accessor: "",
    Cell: ({ row }: { row: { original: SearchHistoryTypes } }) => {
      return (
        <span className="text-sm font-medium text-[#4D4D4D]">
          {row?.original?.suit_number}
        </span>
      );
    },
  },
  {
    Header: "Status",
    accessor: "",
    Cell: ({ row }: { row: { original: SearchHistoryTypes } }) => {
      return (
        <div
          className={clsx(
            "w-fit h-full flex items-center gap-x-1 p-2 rounded-lg bg-[#00AD201A]",
            row?.original?.status === "pending" && "bg-[#e3e3a7]",
          )}
        >
          <div
            className={clsx(
              "w-[5px] h-[5px] rounded-full ",
              row?.original?.status === "pending"
                ? "bg-[#ADAD00]"
                : "bg-[#00A63E]",
            )}
          />
          <span
            className={clsx(
              "text-xs font-medium ",
              row?.original?.status === "pending"
                ? "text-[#ADAD00]"
                : "text-[#00A63E]",
            )}
          >
            {row?.original?.status}
          </span>
        </div>
      );
    },
  },

  {
    Header: "Date",
    accessor: "action",
    Cell: ({ row }: { row: { original: SearchHistoryTypes } }) => {
      return (
        <span className="text-sm font-medium text-[#4D4D4D]">
          {moment(row?.original?.created_at).format("MMM D, YYYY h:mma")}
        </span>
      );
    },
  },
  {
    Header: "Action",
    accessor: "",
    Cell: ({ row }: { row: { original: SearchHistoryTypes } }) => {
      const dispatch = useAppDispatch();

      return (
        <Menu>
          <MenuButton className="flex items-center justify-center rounded-lg hover:bg-gray-100 h-[30px] w-[30px]">
            <img src={VERTICAL_OPTIONS} className="w-[20px] h-[20px] " alt="" />
          </MenuButton>
          <MenuItems
            anchor="bottom end"
            portal
            className="bg-white rounded-xl w-[139px] p-1 flex flex-col shadow-xl border border-gray-100 focus:outline-none z-50"
          >
            <MenuItem>
              <button
                onClick={() => {
                  dispatch(setCaseDetailModal(true));
                  dispatch(setSelectedCaseDetails(row?.original));
                }}
                className="flex items-center gap-x-2 p-2 rounded-lg hover:bg-[#F5F5F5] w-full"
              >
                <img src={EYE} className="w-[20px] h-[20px]" alt="" />
                <span className="text-customDark font-normal text-sm">
                  View
                </span>
              </button>
            </MenuItem>
            <MenuItem>
              <button
                onClick={() => {
                  dispatch(setCaseFormModal(true));
                  dispatch(setSelectedCaseDetails(row?.original));
                  dispatch(setEditMode(true));
                }}
                className="flex items-center p-2 gap-x-2 rounded-lg hover:bg-[#F5F5F5] w-full"
              >
                <img src={PENCIL} className="w-[20px] h-[20px]" alt="" />
                <span className="text-customDark font-normal text-sm">
                  Edit
                </span>
              </button>
            </MenuItem>
            <MenuItem>
              <button
                onClick={() => {
                  dispatch(setDeleteModal(true));
                  dispatch(setSelectedCaseDetails(row?.original));
                }}
                className="flex items-center p-2 gap-x-2 rounded-lg hover:bg-[#FB2C360D] w-full"
              >
                <img src={TRASH_CAN} className="w-[20px] h-[20px]" alt="" />
                <span className="text-[#FB2C36] font-normal text-sm">
                  Delete
                </span>
              </button>
            </MenuItem>
          </MenuItems>
        </Menu>
      );
    },
  },
];
export const COURT_COLUMN = [
  {
    Header: "Property Title",
    accessor: "",
    Cell: ({ row }: { row: { original: SearchHistoryTypes } }) => {
      return (
        <span className="text-sm font-medium text-[#4D4D4D]">
          {row?.original?.title}
        </span>
      );
    },
  },
  {
    Header: "Location",
    accessor: "",
    Cell: ({ row }: { row: { original: SearchHistoryTypes } }) => {
      return (
        <span className="text-sm font-medium text-[#4D4D4D]">
          {row?.original?.address}
        </span>
      );
    },
  },

  {
    Header: "Status",
    accessor: "",
    Cell: ({ row }: { row: { original: SearchHistoryTypes } }) => {
      return (
        <div
          className={clsx(
            "w-fit h-full flex items-center gap-x-1 p-2 rounded-lg bg-[#00AD201A]",
            row?.original?.status === "pending" && "bg-[#e3e3a7]",
          )}
        >
          <div
            className={clsx(
              "w-[5px] h-[5px] rounded-full ",
              row?.original?.status === "pending"
                ? "bg-[#ADAD00]"
                : "bg-[#00A63E]",
            )}
          />
          <span
            className={clsx(
              "text-xs font-medium ",
              row?.original?.status === "pending"
                ? "text-[#ADAD00]"
                : "text-[#00A63E]",
            )}
          >
            {row?.original?.status}
          </span>
        </div>
      );
    },
  },

  {
    Header: "Date",
    accessor: "action",
    Cell: ({ row }: { row: { original: SearchHistoryTypes } }) => {
      return (
        <span className="text-sm font-medium text-[#4D4D4D]">
          {moment(row?.original?.created_at).format("MMM d, YYYY h:mma")}
        </span>
      );
    },
  },
  {
    Header: "Action",
    accessor: "",
    Cell: ({ row }: { row: { original: SearchHistoryTypes } }) => {
      const navigate = useNavigate();
      const dispatch = useAppDispatch();

      return (
        <div className="flex items-center gap-x-2">
          <button
            onClick={() => {
              dispatch(setCaseDetailModal(true));
              dispatch(setSelectedCaseDetails(row?.original));
            }}
            className="flex items-center gap-x-2 p-2 rounded-lg bg-globalGold hover:bg-opacity-75"
          >
            <span className="text-white font-normal text-sm">See Details </span>
          </button>
          <Menu>
            <MenuButton className="">
              <img src={DOTS_BTN} className="w-[32px] h-[32px] " alt="" />
            </MenuButton>
            <MenuItems
              anchor="bottom end"
              portal
              className="bg-white shadow-blur rounded-xl w-[139px] p-1 flex flex-col focus:outline-none z-50"
            >
              <MenuItem>
                <button
                  onClick={() => {
                    dispatch(setCaseFormModal(true));
                    dispatch(setSelectedCaseDetails(row?.original));
                    dispatch(setEditMode(true));
                  }}
                  className="flex items-center p-2 gap-x-2 rounded-lg hover:bg-[#F5F5F5] w-full"
                >
                  <img src={PENCIL} className="w-[20px] h-[20px]" alt="" />
                  <span className="text-customDark font-normal text-sm">
                    Edit
                  </span>
                </button>
              </MenuItem>
              <MenuItem>
                <button
                  onClick={() => {
                    dispatch(setDeleteModal(true));
                    dispatch(setSelectedCaseDetails(row?.original));
                  }}
                  className="flex items-center p-2 gap-x-2 rounded-lg hover:bg-[#FB2C360D] w-full"
                >
                  <img src={TRASH_CAN} className="w-[20px] h-[20px]" alt="" />
                  <span className="text-[#FB2C36] font-normal text-sm">
                    Delete
                  </span>
                </button>
              </MenuItem>
            </MenuItems>
          </Menu>
        </div>
      );
    },
  },
];
export const USER_COLUMN = [
  {
    Header: "Name",
    accessor: "",
    Cell: ({ row }: { row: { original: UserTypes } }) => {
      return (
        <span className="text-sm font-medium text-[#4D4D4D]">
          {row?.original?.name?.replace(/_/g, " ")}
        </span>
      );
    },
  },
  {
    Header: "Email",
    accessor: "",
    Cell: ({ row }: { row: { original: UserTypes } }) => {
      return (
        <span className="text-sm font-medium text-[#4D4D4D]">
          {row?.original?.email}
        </span>
      );
    },
  },
  {
    Header: "Judicial Division",
    accessor: "",
    Cell: ({ row }: { row: { original: UserTypes } }) => {
      return (
        <>
          {row?.original?.judicial_division ? (
            <span className="text-sm font-medium text-[#4D4D4D]">
              {row?.original?.judicial_division?.name}
            </span>
          ) : (
            <span className="text-sm font-medium text-[#4D4D4D]">-</span>
          )}
        </>
      );
    },
  },

  {
    Header: "Status",
    accessor: "",
    Cell: ({ row }: { row: { original: UserTypes } }) => {
      const queryClient = useQueryClient();
      const [updating, setUpdating] = useState(false);

      const isActive = row?.original?.is_active === 1;

      const handleToggle = async () => {
        setUpdating(true);
        const formData = new FormData();
        formData.append("is_active", isActive ? "false" : "true");

        try {
          const response = await updateUserStatus(row.original.id, formData);
          if (response) {
            toast.success(
              response?.message || "User status updated successfully",
            );
            queryClient.invalidateQueries("users");
          }
        } catch (error: any) {
          toast.error(
            error?.response?.data?.message || "Failed to update user status",
          );
        } finally {
          setUpdating(false);
        }
      };

      return (
        <div className="flex items-center gap-x-3">
          <div
            className={clsx(
              "w-fit h-full flex items-center gap-x-1 p-2 rounded-lg",
              isActive ? " bg-[#00AD201A]" : "bg-[#e3e3a7]",
            )}
          >
            <div
              className={clsx(
                "w-[5px] h-[5px] rounded-full",
                isActive ? "bg-[#00A63E]" : "bg-[#ADAD00]",
              )}
            />
            <span
              className={clsx(
                "text-xs font-medium ",
                isActive ? " text-[#00A63E]" : "text-[#ADAD00]",
              )}
            >
              {isActive ? "Active" : "Inactive"}
            </span>
          </div>
          <button
            type="button"
            onClick={handleToggle}
            disabled={updating}
            className={clsx(
              "relative inline-flex h-5 w-9 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none",
              isActive ? "bg-[#00A63E]" : "bg-gray-200",
              updating && "opacity-50 cursor-not-allowed",
            )}
          >
            <span
              className={clsx(
                "pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out",
                isActive ? "translate-x-4" : "translate-x-0",
              )}
            />
          </button>
        </div>
      );
    },
  },

  {
    Header: "User Type",
    accessor: "",
    Cell: ({ row }: { row: { original: UserTypes } }) => {
      return (
        <div
          className={clsx(
            "w-fit h-full flex items-center gap-x-1 p-2 rounded-3xl border border-borderColor",
          )}
        >
          <div className={clsx("w-[5px] h-[5px] rounded-full bg-globalGold")} />
          <span className={clsx("text-xs font-medium text-[#4D4D4D]")}>
            {row?.original?.type?.replace(/_/g, " ")}
          </span>
        </div>
      );
    },
  },

  {
    Header: "Action",
    accessor: "",
    Cell: ({ row }: { row: { original: UserTypes } }) => {
      const navigate = useNavigate();
      const dispatch = useAppDispatch();
      return (
        <div className="flex items-center gap-x-3">
          <button
            onClick={() => {
              dispatch(setDeleteModal(true));
              dispatch(setSelectedUser(row?.original));
            }}
            className="flex items-center gap-x-1 w-fit rounded-lg px-3 py-2 bg-[#FB2C360D]"
          >
            <img src={TRASH_CAN} className="w-[16px] h-[16px]" alt="" />
            <span className="text-xs font-medium text-[#FB2C36]">Delete</span>
          </button>
        </div>
      );
    },
  },
];
export const STATE_COLUMN = [
  {
    Header: "Name",
    accessor: "",
    Cell: ({ row }: { row: any }) => {
      return (
        <span className="text-sm font-medium text-[#4D4D4D]">
          {row?.original?.name}
        </span>
      );
    },
  },
  {
    Header: "Code",
    accessor: "",
    Cell: ({ row }: { row: any }) => {
      return (
        <span className="text-sm font-medium text-[#4D4D4D]">
          {row?.original?.name}
        </span>
      );
    },
  },
];
export const LGA_COLUMN = [
  {
    Header: "Name",
    accessor: "",
    Cell: ({ row }: { row: any }) => {
      return (
        <span className="text-sm font-medium text-[#4D4D4D]">
          {row?.original?.name}
        </span>
      );
    },
  },
  {
    Header: "State",
    accessor: "",
    Cell: ({ row }: { row: any }) => {
      const { data: states } = useQuery("states", getStates);

      const findState = states?.find(
        (item: any) => item?.id.toString() === row?.original?.state_id,
      )?.name;
      return (
        <span className="text-sm font-medium text-[#4D4D4D]">{findState}</span>
      );
    },
  },
  {
    Header: "Code",
    accessor: "",
    Cell: ({ row }: { row: any }) => {
      return <span className="text-sm font-medium text-[#4D4D4D]">-</span>;
    },
  },
  {
    Header: "Action",
    accessor: "",
    Cell: ({ row }: { row: any }) => {
      const dispatch = useAppDispatch();

      return (
        <div className="flex items-center gap-x-3">
          <button
            onClick={() => {
              dispatch(setLocalgovernmentDeleteModal(true));
              dispatch(setLocalgovernment(row?.original));
            }}
            className="flex items-center gap-x-1 w-fit rounded-lg px-3 py-2 bg-[#FB2C360D]"
          >
            <img src={TRASH_CAN} className="w-[16px] h-[16px]" alt="" />
            <span className="text-xs font-medium text-[#FB2C36]">Delete</span>
          </button>
          <button
            onClick={() => {
              dispatch(setLocalgovernmentModal(true));
              dispatch(setEditMode(true));
              dispatch(setLocalgovernment(row?.original));
            }}
            className="flex items-center gap-x-1 w-fit rounded-lg px-5 py-2 bg-globalGold"
          >
            <img src={EDIT_ICON} className="w-[16px] h-[16px]" alt="" />
            <span className="text-xs font-medium text-white">Edit</span>
          </button>
        </div>
      );
    },
  },
];
export const JUDICIAL_COLUMN = [
  {
    Header: "Division",
    accessor: "",
    Cell: ({ row }: { row: any }) => {
      return (
        <span className="text-sm font-medium text-[#4D4D4D]">
          {row?.original?.name}
        </span>
      );
    },
  },
  // {
  //   Header: "State",
  //   accessor: "",
  //   Cell: ({ row }: { row: any }) => {
  //     const { data: states } = useQuery("states", getStates);

  //     const findState = states?.find(
  //       (item: any) => item?.id.toString() === row?.original?.state_id
  //     )?.name;
  //     return (
  //       <span className="text-sm font-medium text-[#4D4D4D]">{findState}</span>
  //     );
  //   },
  // },
  // {
  //   Header: "Code",
  //   accessor: "",
  //   Cell: ({ row }: { row: any }) => {
  //     return <span className="text-sm font-medium text-[#4D4D4D]">-</span>;
  //   },
  // },
  {
    Header: "Action",
    accessor: "",
    Cell: ({ row }: { row: any }) => {
      const navigate = useNavigate();
      const dispatch = useAppDispatch();
      return (
        <div className="flex items-center gap-x-3">
          <button
            onClick={() => {
              dispatch(setJudicialDivisionDeleteModal(true));
              dispatch(setJudicialDivision(row?.original));
            }}
            className="flex items-center gap-x-1 w-fit rounded-lg px-3 py-2 bg-[#FB2C360D]"
          >
            <img src={TRASH_CAN} className="w-[16px] h-[16px]" alt="" />
            <span className="text-xs font-medium text-[#FB2C36]">Delete</span>
          </button>
          <button
            onClick={() => {
              dispatch(setJudicialDivisionModal(true));
              dispatch(setJudicialDivision(row?.original));
              dispatch(setEditMode(true));
            }}
            className="flex items-center gap-x-1 w-fit rounded-lg px-5 py-2 bg-globalGold"
          >
            <img src={EDIT_ICON} className="w-[16px] h-[16px]" alt="" />
            <span className="text-xs font-medium text-white">Edit</span>
          </button>
        </div>
      );
    },
  },
];
export const PLATFORM_CHARGE = [
  {
    Header: "ID",
    accessor: "",
    Cell: ({ row }: { row: any }) => {
      return (
        <span className="text-sm font-medium text-[#4D4D4D]">
          {row?.original?.id}
        </span>
      );
    },
  },
  {
    Header: "Amount",
    accessor: "",
    Cell: ({ row }: { row: any }) => {
      return (
        <span className="text-sm font-medium text-[#4D4D4D]">
          {formatCurrency({ iso: "en-ng", slug: "NGN" }).format(
            Number(row?.original?.platform_charge),
          )}
        </span>
      );
    },
  },
  {
    Header: "Last Updated",
    accessor: "",
    Cell: ({ row }: { row: any }) => {
      return (
        <span className="text-sm font-medium text-[#4D4D4D]">
          {moment(row?.original?.updated_at).format("MMM D, YYYY h:mma")}
        </span>
      );
    },
  },
  {
    Header: "Actions",
    accessor: "",
    Cell: ({ row }: { row: any }) => {
      const dispatch = useAppDispatch();

      return (
        <div className="flex items-center gap-x-3">
          <button
            onClick={() => dispatch(setPlatformModal(true))}
            className="flex items-center gap-x-1 w-fit rounded-lg px-5 py-2 bg-globalGold"
          >
            <img src={EDIT_ICON} className="w-[16px] h-[16px]" alt="" />
            <span className="text-xs font-medium text-white">Edit</span>
          </button>
        </div>
      );
    },
  },
];
